import React, { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import icon_app_tgs from "assets/svg/icon_app_tgs.svg";

const LoginPromptCard = memo(({
  className,
  onClick,
  imageSrc,
  imageAlt = "Golden SpoonS",
  title,
  subtitle,
  buttonText,
}) => {
  const { t } = useTranslation("translation");
  const homeBrand = useSelector((state) => state.rootReducer.homeBrand);
  const resolvedTitle = title ?? t("goldenSpoonsTitle");
  const resolvedSubtitle =
    subtitle ?? t("loginTitleNow", { brand: homeBrand?.["res-name"] });

  return (
    <div className={className}>
      <div className="login-prompt-logo-wrap">
        <img
          className={`login-prompt-logo ${imageSrc ? "is-avatar" : ""}`}
          src={imageSrc || icon_app_tgs}
          alt={imageAlt}
        />
      </div>
      {resolvedTitle && (
        <div className="login-prompt-title">{resolvedTitle}</div>
      )}
      {resolvedSubtitle && (
        <div className="login-prompt-subtitle">{resolvedSubtitle}</div>
      )}
      <button type="button" onClick={onClick} className="login-prompt-button">
        {buttonText || t("loginWithGoldenGateApp")}
      </button>
    </div>
  );
});

export default styled(LoginPromptCard)`
  padding: 10px 0 12px;

  .login-prompt-logo-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 0 2px;
  }

  .login-prompt-logo {
    width: 72px;
    height: 72px;
    display: block;
    object-fit: contain;
  }

  .login-prompt-logo.is-avatar {
    border-radius: 50%;
    object-fit: cover;
  }

  .login-prompt-title {
    margin: 8px 16px 0;
    color: #1a1a1a;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    font-family: "Manrope-Bold", sans-serif;
  }

  .login-prompt-subtitle {
    margin: 4px 16px 0;
    color: #808080;
    text-align: center;
    font-size: 14px;
    line-height: 22px;
    font-family: "Manrope-Medium", sans-serif;
  }

  .login-prompt-button {
    width: calc(100% - 24px);
    margin: 12px;
    height: 44px;
    border: none;
    border-radius: 6px;
    background: #1a1a1a;
    color: #ffffff;
    font-size: 14px;
    line-height: 20px;
    font-family: "Manrope-Bold", sans-serif;
  }
`;
